import { ModelStateError } from './ModelStateError.es.js';

/** @module Classes */ /** typedoc */
class ResponseError {
    /**
     *
     * @param httpResponseError - httpResponse
     * @returns {ResponseError}
     */
    static fromMonolith(httpResponseError = {}) {
        const data = httpResponseError.data || {};
        const newResponseError = new ResponseError();
        newResponseError.httpCode = httpResponseError['status'];
        newResponseError.code = data['MgCode'];
        newResponseError.message = data['MgReason'];
        newResponseError.errors = (data['MgModelState'] || []).map((error) => {
            return ModelStateError.fromMonolith(error);
        });
        if (ResponseError.hasModelStateErrors(newResponseError.errors)) {
            const error = newResponseError.errors[0];
            newResponseError.code = error.code;
            newResponseError.message = error.message;
        }
        return newResponseError;
    }
    static hasModelStateErrors(errors) {
        return errors && errors.length > 0;
    }
}

export { ResponseError };
